<template>
	<div
		class="flex place-content-between border-b border-slate-100 p-4 hover:bg-sky-50"
	>
		<div>
			<div class="text-secondary-900">{{ suggestion.name }}</div>
			<div class="text-sm text-[#0C58B7]">{{ suggestion.id }}</div>
			<div class="text-secondary-900">
				<!-- {{ suggestion.city }}, {{ suggestion.state }} -->
			</div>
		</div>
		<div class="flex flex-col justify-center">
			<ClipboardCopy :text-to-copy="suggestion.id" />
		</div>
	</div>
</template>

<script setup lang="ts">
import ClipboardCopy from '../presentation/ClipboardCopy.vue'
import type { FuneralHomeGroup } from '@/apiTypes'
import { type PropType } from 'vue'

defineProps({
	suggestion: {
		type: Object as PropType<FuneralHomeGroup>,
		required: true,
	},
})
</script>
